export const ROUTE_AUTH_URL = {
  login: `login`,
  resetPassword: `/auth/resetpassword/:resetPasswordId`,
  forgotPassword: `/auth/forgotpassword`,
  signup: {
    base: `/signup`,
    step1: `/signup/step1`,
    step2: `/signup/step2`,
    step3: `/signup/step3`,
    finish: `/signup/complete`,
  },
};
